<template>

  <material-card icon="mdi-clipboard-text" inline title="Manage Audit Scores">
    <v-card-actions>
      <a @click="$router.back()">
        <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top>
          <v-icon left>mdi-arrow-left</v-icon>back
        </v-btn>
        <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10"
          style="opacity:.6;">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </a>
    </v-card-actions>
    <v-card-component>
      <v-container>
        <v-data-table :headers="headers" :items="scalesList" disable-pagination hide-default-footer>
          <template v-slot:item.id="{item}">
            Acadamic Score Value {{item.startRange}} to {{item.endRange}}
          </template>
          <template v-slot:item.starValue="{item}">
            <v-autocomplete label="Select Score" v-model="item.starValue" clearable
              :items="scoreList" key="id" item-value="value" item-text="value"> </v-autocomplete>
          </template>
        </v-data-table>
      </v-container>
    </v-card-component>
  </material-card>

</template>

<script>
import CONSTANTS from '@/utils/constants'
import { mapGetters } from 'vuex'
// import _ from 'lodash'
// import stores from '@/stores'
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'
// startRange endRange
export default {
  components: { VCardComponent, MaterialCard },
  created: async function () {
    this.academicYearID = this.academicYear.id
    await this.getScaleList()
    await this.getScoreList()
  },
  computed: {
    ...mapGetters({
      academicYear: 'getAcademicYear'
    })
  },
  watch: {
    academicYear: async function (val) {
      console.log(val)
      this.academicYearID = val.id
      this.getScaleList()
    }
  },
  data () {
    return {
      scoreList: [],
      scalesList: [],
      academicYearID: '',
      headers: [
        { text: 'Acadamic Score Value', value: 'id', width: '60%' },
        { text: 'Score', value: 'starValue' },
        { text: 'Remark', value: 'remark' }
      ]
    }
  },
  methods: {
    getScaleList: async function () {
      try {
        if (this.academicYearID) {
          let rows = await http.get(`${CONSTANTS.API_URL}/api/center-audit/score/scales/${this.academicYearID}`)
          console.log(rows.data)
          this.scalesList = rows.data
        }
      } catch (e) {
        console.log(e)
      }
    },
    getScoreList: async function () {
      try {
        let rows = await http.get(`${CONSTANTS.API_URL}/api/center-audit/score/points`)
        console.log(rows.data)
        this.scoreList = rows.data
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style scoped>
.header-title {
  font-size: 16px;
  color: dimgray;
}
.hr-divider {
  border: solid white;
  border-bottom: solid 3px rgba(0, 0, 0, 0.42);
}
.percentage {
  color: #fff;
  font-size: 9px;
}
</style>
